import api from './api'
import {
  ConteudoOnboardingAdmin,
  ConteudoOnboardingRequest,
  EtapaOnboarding,
  Onboarding,
} from '@/types/onboarding'

const BASE_URL = '/api/v1/onboarding'

/**
 * Primeiro acesso. O usuário vem do token — não há (nem deve haver) parâmetro de
 * usuário em nenhuma destas chamadas.
 */
export const onboardingService = {
  obter: async (): Promise<Onboarding> => {
    const response = await api.get<Onboarding>(BASE_URL)
    return response as unknown as Onboarding
  },

  concluirEtapa: async (etapa: EtapaOnboarding): Promise<Onboarding> => {
    const response = await api.post<Onboarding>(`${BASE_URL}/etapas/${etapa}/concluir`, {})
    return response as unknown as Onboarding
  },

  /** Libera a criação de reservas. O novo papel só vale no PRÓXIMO token. */
  concluir: async (): Promise<void> => {
    await api.post(`${BASE_URL}/concluir`, {})
  },

  listarConteudos: async (): Promise<ConteudoOnboardingAdmin[]> => {
    const response = await api.get<ConteudoOnboardingAdmin[]>(`${BASE_URL}/conteudos`)
    return response as unknown as ConteudoOnboardingAdmin[]
  },

  /**
   * Edição do material pelo ADMIN. O endpoint existia desde a entrega do wizard, mas
   * nenhuma tela o chamava — na prática, não havia como inserir o conteúdo sem chamar a
   * API na mão.
   */
  salvarConteudo: async (
    etapa: EtapaOnboarding,
    request: ConteudoOnboardingRequest
  ): Promise<ConteudoOnboardingAdmin> => {
    return await api.put<ConteudoOnboardingAdmin>(`${BASE_URL}/conteudos/${etapa}`, request)
  },
}
